import React, { useEffect, useReducer, useState } from "react";
/// Scroll
// import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import { Link } from "react-router-dom";

import { MenuList } from "../../Enums/Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";

const reducer = (previousState, updatedState) => ({
	...previousState,
	...updatedState,
});

const initialState = {
	active: "",
	activeSubmenu: "",
};

const SideBar = (props) => {
	const [active, setActive] = useState("");
	const [state, setState] = useReducer(reducer, initialState);
	const lang = useSelector((state) => state.auth?.lang);

	//For scroll
	const [hideOnScroll, setHideOnScroll] = useState(true);
	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > prevPos.y;
			if (isShow !== hideOnScroll) setHideOnScroll(isShow);
		},
		[hideOnScroll]
	);

	const handleMenuActive = (status) => {
		setState({ active: status });
		if (
			state.active === status &&
			MenuList.filter((res) => res?.title === status)[0]?.hasOwnProperty(
				"content"
			)
		) {
			setState({ active: "" });
		}
	};

	const handleSubmenuActive = (status) => {
		setState({ activeSubmenu: status });
		if (state.activeSubmenu === status) {
			setState({ activeSubmenu: "" });
		}
	};

	useEffect(() => {
		let page = window.location.pathname;
		let filter = MenuList?.filter((res) => `${res.to}` === page?.split("/")[1]);

		if (filter.length > 0) handleMenuActive(filter[0].title);
	}, [window.location.pathname]);

	/// Path
	let path = window.location.pathname;
	path = path.split("/");
	path = path[path.length - 1];
	return (
		<div className="deznav">
			<div className="deznav-scroll">
				<ul className="metismenu" id="menu">
					{MenuList.map((data, index) => {
						let menuClass = data.classsChange;
						return (
							<li
								className={` ${state.active === data.title ? "mm-active" : ""}`}
								key={index}>
								{data.content && data.content.length > 0 ? (
									<>
										<Link
											to={"#"}
											className="has-arrow d-flex justify-content-between position-relative"
											onClick={() => {
												handleMenuActive(data.title);
											}}>
											<div>
												{state.active === data.title
													? data.iconActive
													: data.iconDeactive}
												<span className="nav-text">
													{Translate[lang][data.text]}
												</span>
											</div>
											{state.active === data.title ? (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M8 12H16"
														stroke="white"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
														stroke="white"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											) : (
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg">
													<path
														d="M8 12H16"
														stroke="#7B7B7B"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M12 16V8"
														stroke="#7B7B7B"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
														stroke="#7B7B7B"
														strokeWidth="1.5"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											)}
										</Link>
										<Collapse in={state.active === data.title ? true : false}>
											<ul
												className={`${
													menuClass === "mm-collapse" ? "mm-show" : ""
												}`}>
												{data.content &&
													data.content?.map((data, index) => {
														return (
															<li
																key={index}
																className={`${
																	state.activeSubmenu === data.title
																		? "mm-active"
																		: ""
																}`}>
																{data.content && data.content.length > 0 ? (
																	<>
																		<Link
																			to={data.to}
																			className={
																				data.hasMenu ? "has-arrow" : ""
																			}
																			onClick={() => {
																				handleSubmenuActive(data.title);
																			}}>
																			{Translate[lang][data.text]}
																		</Link>
																		<Collapse
																			in={
																				state.activeSubmenu === data.title
																					? true
																					: false
																			}>
																			<ul
																				className={`${
																					menuClass === "mm-collapse"
																						? "mm-show"
																						: ""
																				}`}>
																				{data.content &&
																					data.content.map((data, index) => {
																						return (
																							<li key={index}>
																								<Link
																									className={`${
																										path === data.to
																											? "mm-active"
																											: ""
																									}`}
																									to={data.to}>
																									{Translate[lang][data.text]}
																								</Link>
																							</li>
																						);
																					})}
																			</ul>
																		</Collapse>
																	</>
																) : (
																	<Link
																		to={data.to}
																		onClick={() => setActive(data.text)}
																		className={`${
																			active === data.text ? "active-link" : ""
																		}`}>
																		{Translate[lang][data.text]}
																	</Link>
																)}
															</li>
														);
													})}
											</ul>
										</Collapse>
									</>
								) : (
									<Link
										to={data.to}
										className="d-flex"
										onClick={() => handleMenuActive(data.title)}>
										{state.active === data.title
											? data.iconActive
											: data.iconDeactive}
										<span className="nav-text">
											{Translate[lang][data.text]}
										</span>
									</Link>
								)}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

export default SideBar;
